var render = function render(){var _vm=this,_c=_vm._self._c;return _c('User',{attrs:{"project":_vm.vid,"embed":"","data-testid":"user-component"}})
}
var staticRenderFns = []

export { render, staticRenderFns }